/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_ResetInputs */

const vi_einvoice_draft_reset = /** @type {(inputs: Einvoice_Draft_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo lại từ đơn hàng`)
};

/**

* @param {Einvoice_Draft_ResetInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_reset = /** @type {((inputs?: Einvoice_Draft_ResetInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_ResetInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_reset(inputs)
});